import Vue from "vue";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from "vee-validate";
import { required, alpha, confirmed } from "vee-validate/dist/rules";
import ko from "vee-validate/dist/locale/ko.json";
import * as rules from "vee-validate/dist/rules";

const customRules = {
  truthy: {
    validate: (value, { bool }) => {
      if (bool) return true;
      else if (bool === null) return "인증이 필요합니다.";
      else if (bool === false) return "이미 가입된 이메일입니다.";
    },
    params: [{ name: "bool" }],
  },
  passwordConfirm: {
    validate: (value, { origin: [origin] }) => {
      if (value === origin) return true;
      return `비밀번호가 일치하지 않습니다.`;
    },
    params: [{ name: "origin", type: String }],
  },
};

ko.messages = {
  ...ko.messages,
  required: () => "필수 입력 항목입니다.",
  regex: () => "비밀번호 형식이 올바르지 않습니다.",
  is: (name) => `${name}이 일치하지 않습니다.`,
};

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

const mergedRules = { ...rules, ...customRules };
Object.keys(mergedRules).forEach((rule) => {
  extend(rule, mergedRules[rule]);
});

localize("ko", ko);
